module.exports = __webpack_public_path__ + "img/b5.789e5d58.png";